import React, { useState } from "react";
import { graphql } from "gatsby";
import Page from "~/models/page";
import Resource from "~/models/resource";
import SEO from "~/views/components/generic/seo";
import structuredData from "~/helpers/structured-data";
import Frame from "~/views/layout/frame";
import Container from "~/views/layout/container";
import Breadcrumb from "~/views/compositions/navigation/breadcrumb";
import Header from "~/views/compositions/navigation/header";
import ResourceCard from "~/views/components/resource/card";
import PageHeader from "~/views/compositions/generic/header";
import NewsletterSubscription from "~/views/components/newsletter/subscription";
import Tagline from "~/views/components/generic/tagline";

type Props = {
  data: any;
};

const ResourceList = ({ data }: Props) => {
  const page = new Page(data.page as any);

  const resources = data.resources.nodes.map(
    (resource: any) => new Resource(resource as any)
  );

  return (
    <Frame>
      <Header />
      <Tagline />
      <Breadcrumb breadcrumb={page.breadcrumb} className="xl:max-w-[1328px]" />

      <PageHeader
        title="UXデザインに役立つテンプレート集"
        description={page.description}
      />

      <Container className="pb-container">
        <ul className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 grid-gap-x grid-gap-y">
          {resources.map((resource: any) => (
            <li key={resource.id}>
              <ResourceCard resource={resource} />
            </li>
          ))}
        </ul>
      </Container>

      <NewsletterSubscription type="dark" />
    </Frame>
  );
};

export default ResourceList;

export const Head = ({ data }: Props) => {
  const page = new Page(data.page as any);
  const sd = structuredData(page);

  return <SEO page={page} sd={sd} />;
};

export const query = graphql`
  query ResourceList {
    page: pageMdx(
      filter: { frontmatter: { url: { pathname: { eq: "/resources/" } } } }
    ) {
      id
      frontmatter {
        id
        title
        image {
          ...AssetFields
        }
        description
        breadcrumb {
          id
          yamlId
          name
          pathname
        }
        url {
          yamlId
          name
          pathname
        }
        type
        releasedAt
        updatedAt
      }
    }
    resources: allPageMdx(
      filter: { frontmatter: { type: { eq: "Resource" } } }
      sort: { fields: { releasedAt: DESC } }
    ) {
      nodes {
        id
        frontmatter {
          id
          title
          type
          url {
            yamlId
            name
            pathname
          }
          labels {
            yamlId
            name
            slug
            description
          }
          releasedAt
          updatedAt
          description
          image {
            ...AssetFields
          }
        }
        excerpt
      }
    }
  }
`;
